<script setup>
import { __ } from '@/utils';
import { computed, inject, ref } from 'vue';

const emit = defineEmits(['numberPlan'])
const { plan } = defineProps({
    plan: Object,
});

const features = ref('');
const availableGB = plan?.volumes?.[0]?.volume + plan?.volumes?.[0]?.unit.toUpperCase();
const price = plan?.price;

const { values } = inject('form');
const dateValidity = computed(() => {
    const date = new Date(values.departureDate);
    date.setDate(date.getDate() + plan.duration);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
});

const title = availableGB.replace('MINUTES', '');

const usageTypes = {
	'data' : __('Data only'),
	'call' : __('SMS - Minutes'),
	'data_calls' : __('Surfing and talking'),
};
const  roamingUsage = ref('');
const volumes = plan?.volumes.map(item => item.usage_type);

if(volumes.length === 1){
	roamingUsage.value = usageTypes['data'];
} else if(volumes.length === 2){
	roamingUsage.value = usageTypes['call'];
} else {
	roamingUsage.value = usageTypes['data_calls'];
}


features.value = [
    {'featured': __('valid until') + ' ' + dateValidity.value},
    {'featured' : __('at the price of') + ' ' + `<strong>₪${price}</strong>`},
];
</script>
<template>
    <div class="tile-plan tile-plan--roaming-step">
        <img :src="`${theme_path.url}/resources/images/svg/selected.svg`" alt="telecom icon" class="tile__selected" /> 
        <header class="tile__head">
            <strong class="label">
                <i class="tile__head-icon" v-if="plan?.alpha2">
                    <img :src="`https://flagcdn.com/w40/${plan.alpha2.toLowerCase()}.png`" alt="">
                </i>
                {{ plan.name_heb }}
            </strong>

            <div class="tile__title" v-if="availableGB">
                <strong class="tile__title-gb">
                    {{ title }}
                </strong>
            </div><!-- /.tile__title -->
            <div class="tile__title">
                <strong>
                    {{ roamingUsage }}
                </strong>
            </div><!-- /.tile__title -->
        </header>

        <div class="tile__body">
            <div class="tile__list" v-if="features">
                <ul>
                    <li v-for="(feature, featuredIndex) in features" :index="featuredIndex">
                        <span dir="rtl" v-html="feature.featured"></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
